import { APP_PDC_URL, API_TYPES_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
export const classificationConstants = {
  RESET_CLASSIFICATION: "RESET_CLASSIFICATION",
  SAVE_CLASSIFICATION_START: "SAVE_CLASSIFICATION_START",
  SAVE_CLASSIFICATION_SUCCESS: "SAVE_CLASSIFICATION_SUCCESS",
  SAVE_CLASSIFICATION_ERROR: "SAVE_CLASSIFICATION_ERROR",
  GET_TYPES_START: "GET_TYPES_START",
  GET_TYPES_SUCCESS: "GET_TYPES_SUCCESS",
  GET_TYPES_ERROR: "GET_TYPES_ERROR"
};

export function resetClassification() {
  return function(dispatch) {
    dispatch({
      type: classificationConstants.RESET_CLASSIFICATION
    });
  };
}

export function saveClassification(documentID,
  dataPayload) {

  return (dispatch, getState) => {

    const auth = getState().auth;
    const main = getState().main;
    const accountantIdSelected = main.accountantIdSelected;
    const clientIdSelected = main.clientIdSelected;

    const itemAccount = {
      accountantId: accountantIdSelected,
      itemId: clientIdSelected
    };

    let request = {
      method: "PATCH",
      url: APP_PDC_URL + "/v2/documents/" + documentID + "/classification",
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
      data: { ...dataPayload, ...itemAccount }
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: classificationConstants.SAVE_CLASSIFICATION_START
      });

      return callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: classificationConstants.SAVE_CLASSIFICATION_SUCCESS
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: classificationConstants.SAVE_CLASSIFICATION_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response.code ? response.code : 500
            }
          });
          reject();
        });
    });
  };
}

export function getDocumentType() {
  let urlRequest = API_TYPES_URL;
  return (dispatch,getState) => {

    const auth = getState().auth;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: classificationConstants.GET_TYPES_START
      });

      let request = {
        method: "GET",
        url: urlRequest,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          dispatch({
            type: classificationConstants.GET_TYPES_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: classificationConstants.GET_TYPES_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response && response.code ? response.code : 500
            }
          });
          reject();
        });
    });
  };
}
